import { Emitter } from "pixi-particles";
import App from "../App";
import Layout from "../utils/Layout";
import { Ease } from "../Ease";
import { Timeline } from "../Timeline";
import { Container, Point, ParticleContainer } from "pixi.js";

export default class Trail extends Container {
    private emitterPos: Point;
    private emitter: Emitter;
    private callback: () => void;
    private timeline: Timeline;

    constructor(positions: Point[], callback: () => void = null) {
        super();

        this.callback = callback;
        //
        this.emitterPos = positions.shift();

        const container = new ParticleContainer(5000, {
            position: true,
            rotation: false,
            uvs: false,
            tint: true,
        });

        this.emitter = App.assets.getParticle("trail", container);

        this.emitter.updateOwnerPos(this.emitterPos.x, this.emitterPos.y);

        this.timeline = new Timeline();

        positions.forEach((pos, index) => {
            this.timeline.to(this.emitterPos, 1 / positions.length, {
                x: pos.x,
                y: pos.y,
                ease: Ease.None,
                onUpdate: () => {
                    if (this && !App.isObjectDestroyed(this)) {
                        this.emitter.updateOwnerPos(
                            this.emitterPos.x,
                            this.emitterPos.y
                        );
                    }
                },
                callbackScope: this,
            });
        });

        this.timeline.addCallback(this.onComplete, "+=2", [], this);

        this.addChild(container);
    }

    private onComplete() {
        this.emitter.destroy();
        if (this.parent) {
            this.parent.removeChild(this);
        }

        this.destroy();

        if (this.callback) {
            this.callback();
        }
    }

    // private createTexture(r1: number, r2: number, resolution: number) {
    //     const c = (r2 + 1) * resolution;
    //     r1 *= resolution;
    //     r2 *= resolution;

    //     const canvas = document.createElement("canvas");
    //     const context = canvas.getContext("2d");
    //     canvas.width = canvas.height = Math.max(8, c * 2 * Layout.globalScale);

    //     const gradient = context.createRadialGradient(c, c, r1, c, c, r2);
    //     gradient.addColorStop(0, "rgba(255,255,255,1)");
    //     gradient.addColorStop(1, "rgba(255,255,255,0)");

    //     context.fillStyle = gradient;
    //     context.fillRect(0, 0, canvas.width, canvas.height);

    //     return Texture.fromCanvas(canvas);
    // }
}
